var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMocktail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.98792 18.067V12.4336C11.749 12.0029 14.425 8.85372 14.425 5.26135C14.425 3.90335 14.0479 2.21427 13.3943 0.576829C13.2555 0.22859 12.9179 0 12.5432 0H1.87577C1.50079 0 1.16326 0.22859 1.02456 0.576876C0.434478 2.05533 -0.0239765 3.79808 0.000971813 5.40623C0.000971813 5.40774 0.00139639 5.40925 0.00139639 5.41071C0.0740247 8.9537 2.72798 12.02 6.43056 12.4336V18.067C3.97916 18.2676 2.10007 19.3572 2.10007 19.9051C2.10007 20.5103 4.38744 21 7.20957 21C10.0316 21 12.3193 20.5103 12.3193 19.9051C12.3193 19.3572 10.4395 18.2674 7.98792 18.067ZM2.31635 1.55731H12.1024C12.591 2.88985 12.8677 4.22051 12.8677 5.2614C12.8677 5.51414 12.8452 5.76178 12.813 6.00617C12.3261 5.88483 11.8214 5.86879 11.2801 6.06149C9.8663 6.56484 8.94977 6.88724 7.51145 6.32319C6.08128 5.76192 5.17753 3.21243 3.46256 3.40641C2.78122 3.48309 2.19666 3.7072 1.66897 4.01851C1.7914 3.24601 2.00504 2.40654 2.31635 1.55731Z",
    fill: "#E9A5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMocktail);
export default __webpack_public_path__ + "static/media/mocktail.f538ecadcf0bebb51044771c8158f066.svg";
export { ForwardRef as ReactComponent };